import { create } from '@/store'
import { devtools } from 'zustand/middleware'

const useTenantConfigStore = create(
  devtools(
    (set) => ({
      tenantConfig: null,
      setTenantConfig: (tenantConfig) => set({ tenantConfig }),
    }),
    {
      name: 'user-status-store',
    },
  ),
)
export default useTenantConfigStore
